var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "person_book"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_634_8298",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_634_8298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_book_2",
    d: "M9.99992 14.9998C9.22214 14.9998 8.47909 15.1214 7.77075 15.3644C7.06242 15.6075 6.41659 15.9721 5.83325 16.4582V16.6665H14.1666V16.4582C13.5833 15.9721 12.9374 15.6075 12.2291 15.3644C11.5208 15.1214 10.7777 14.9998 9.99992 14.9998ZM9.99992 13.3332C10.9583 13.3332 11.8541 13.479 12.6874 13.7707C13.5208 14.0623 14.2916 14.4721 14.9999 14.9998V3.33317H4.99992V14.9998C5.70825 14.4721 6.47909 14.0623 7.31242 13.7707C8.14575 13.479 9.04158 13.3332 9.99992 13.3332ZM9.99992 9.99984C9.6527 9.99984 9.35756 9.87831 9.1145 9.63525C8.87145 9.3922 8.74992 9.09706 8.74992 8.74984C8.74992 8.40262 8.87145 8.10748 9.1145 7.86442C9.35756 7.62137 9.6527 7.49984 9.99992 7.49984C10.3471 7.49984 10.6423 7.62137 10.8853 7.86442C11.1284 8.10748 11.2499 8.40262 11.2499 8.74984C11.2499 9.09706 11.1284 9.3922 10.8853 9.63525C10.6423 9.87831 10.3471 9.99984 9.99992 9.99984ZM4.99992 18.3332C4.54159 18.3332 4.14922 18.17 3.82284 17.8436C3.49645 17.5172 3.33325 17.1248 3.33325 16.6665V3.33317C3.33325 2.87484 3.49645 2.48248 3.82284 2.15609C4.14922 1.8297 4.54159 1.6665 4.99992 1.6665H14.9999C15.4583 1.6665 15.8506 1.8297 16.177 2.15609C16.5034 2.48248 16.6666 2.87484 16.6666 3.33317V16.6665C16.6666 17.1248 16.5034 17.5172 16.177 17.8436C15.8506 18.17 15.4583 18.3332 14.9999 18.3332H4.99992ZM9.99992 11.6665C10.8055 11.6665 11.493 11.3818 12.0624 10.8123C12.6319 10.2429 12.9166 9.55539 12.9166 8.74984C12.9166 7.94428 12.6319 7.25678 12.0624 6.68734C11.493 6.11789 10.8055 5.83317 9.99992 5.83317C9.19436 5.83317 8.50686 6.11789 7.93742 6.68734C7.36797 7.25678 7.08325 7.94428 7.08325 8.74984C7.08325 9.55539 7.36797 10.2429 7.93742 10.8123C8.50686 11.3818 9.19436 11.6665 9.99992 11.6665Z",
    fill: "url(#paint0_linear_634_8298)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_634_8298",
    x1: 9.99992,
    y1: 1.6665,
    x2: 9.99992,
    y2: 18.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.6b4049d89ee9b12643ffe7c118dc25a8.svg";
export { ForwardRef as ReactComponent };